<template>
  <div>
    <div>
      <b-row>
        <!-- จราจรล่าช้า และหยุดนิ่ง -->
        <b-col cols="12">
          <div>
            <!-- <b-img
              src="@/assets/images/icons/analyticSciFi/cartotal.svg"
              style="margin-top: -20px"
              height="80"
            /> &nbsp;&nbsp; -->
            <span style="font-size: 58px; font-weight: 500; color: #46E0E5; text-shadow: 0 0 8px #46E0E5;">
              {{ cam_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
            </span>
            <span style="font-size: 30px; font-weight: 100; color: #ffffff">กล้อง</span>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol,
  // BImg,
} from 'bootstrap-vue'
import axios from '@axios'
// import ModalPhase from '@/views/traffiscifi/detailfi/ModalGraphPhase.vue'

export default {
  // name: 'SVGAnimation',
  components: {
    BRow,
    BCol,
    // BImg,

  },
  data() {
    return {
      // animate: false,
      iconColor: 'rgba(0, 228, 255, 0.5)',

      cam_total: '',

    }
  },
  computed: {

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.isSmallScreen)
  },
  mounted() {
    window.addEventListener('resize', this.isSmallScreen)
    this.getStaticAIDetail()
    this.getCamTotal()
    this.interval = setInterval(() => {
      window.addEventListener('resize', this.isSmallScreen)
      this.getStaticAIDetail()
      this.getCamTotal()
    }, 100000)
  },
  methods: {
    getStaticAIDetail() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getStaticAIDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.TotalCount = response.data[1][7].countNum
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getStaticAIDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.TotalCount = response.data[1][7].countNum
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    // toggleAnimation() {
    //   this.animate = !this.animate
    // },
    isSmallScreen() {
      return window.innerWidth <= 850
    },

    getCamTotal() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getCamTotal-G', { wid: this.$route.query.wid })
          .then(response => {
            this.cam_total = response.data[0].cam_total
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getCamTotal', { wid: this.$route.query.wid })
          .then(response => {
            this.cam_total = response.data[0].cam_total
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
  },

}
</script>

<style scoped lang="scss">

</style>
